import uuidv4 from 'uuid/v4.js';
import axios from 'axios';

/*global async */

var Request = /*#__PURE__*/function () {
  function Request(params) {
    if (params === void 0) {
      params = {};
    }

    var _params = params,
        _params$retryDelay = _params.retryDelay,
        retryDelay = _params$retryDelay === void 0 ? 1000 : _params$retryDelay,
        _params$concurrentReq = _params.concurrentRequests,
        concurrentRequests = _params$concurrentReq === void 0 ? 1 : _params$concurrentReq,
        transport = _params.transport,
        preRequestHook = _params.preRequestHook,
        postRequestHook = _params.postRequestHook;
    this.retryDelay = retryDelay;
    this.concurrentRequests = concurrentRequests;
    this.requests = {};
    this.transport = transport || axios;
    this.preRequestHook = preRequestHook || async(function (config) {
      return config;
    });
    this.postRequestHook = postRequestHook || async(function (_ref) {
      var response = _ref.response;
      return response;
    });
  }

  var _proto = Request.prototype;

  _proto.send = async function send(_ref2) {
    var config = _ref2.config,
        _ref2$onStart = _ref2.onStart,
        onStart = _ref2$onStart === void 0 ? function () {} : _ref2$onStart,
        _ref2$onSuccess = _ref2.onSuccess,
        onSuccess = _ref2$onSuccess === void 0 ? function () {} : _ref2$onSuccess,
        _ref2$onError = _ref2.onError,
        onError = _ref2$onError === void 0 ? function () {} : _ref2$onError;
    var id = config.id || uuidv4();
    config.id = id;
    config = await this.preRequestHook(config);
    await onStart({
      id: id,
      config: config
    });
    var requestInProgress = true;

    while (requestInProgress) {
      var requestsInProgress = Object.keys(this.requests).length;
      var isRequestQueueReady = requestsInProgress < this.concurrentRequests;

      if (isRequestQueueReady) {
        try {
          var _response, _response$data;

          if (!config) {
            throw Error('config must be provided');
          }

          this.requests[id] = config;
          var response = await this.transport(config);

          if (!response || !response.data) {
            throw {
              message: 'no data in response',
              response: response
            };
          }

          if ((_response = response) !== null && _response !== void 0 && (_response$data = _response.data) !== null && _response$data !== void 0 && _response$data.error) {
            throw response.data;
          }

          requestInProgress = false;
          response = await this.postRequestHook({
            config: config,
            response: response
          });
          delete this.requests[id];
          await onSuccess({
            id: id,
            response: response,
            config: config
          });
          return response;
        } catch (error) {
          requestInProgress = false;
          delete this.requests[id];
          await onError({
            id: id,
            error: error,
            config: config
          });
          throw error;
        }
      }

      await this.wait(this.retryDelay);
    }
  };

  _proto.wait = function wait(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  return Request;
}();

export { Request as default };
//# sourceMappingURL=request.js.map
